// extracted by mini-css-extract-plugin
export default {"root":"_1xMm_","stat":"_15aaY","label":"_3XJHo"};